import React, { PureComponent } from "react";
import { connect } from "react-redux";
import colors from "@constants/color";
import { ActivityIndicator, View, StyleSheet, Text } from "react-native";
import analytics from "@services/analytics";
import FetchCMSEntity from "../../components/CMS/FetchCMSEntity";
import { getCMSEntityById } from "../../services/cmsV2-api";
import { getPDG, resetClCache } from "../../services/api";
import { DPG_EVENTS } from "../../constants/analyticsEventsCT";

class DailyGreetings extends PureComponent {
  state = {
    entityId: null,
  };

  async componentDidMount() {
    try {
      const { params: { entityId } = {}, user_id } = this.props.route;
      const { data: pdgData } = await getPDG();
      await resetClCache();
      const { data } = await getCMSEntityById({
        id: entityId,
        user_id: this.props.user_id,
      });
      analytics.trackEvent(DPG_EVENTS.DPG_LANDING, {});
      this.setState({
        entityId,
      });
    } catch (e) {
      console.log(e);
    }
  }

  trackEvent = (type) => {
    switch (type) {
      case DPG_EVENTS.DPG_SAVE:
        analytics.trackEvent(DPG_EVENTS.DPG_SAVE, {});
        return;
      case DPG_EVENTS.DPG_SHARE:
        analytics.trackEvent(DPG_EVENTS.DPG_SHARE, {});
        return;
      case DPG_EVENTS.DPG_BANNER_TAP:
        analytics.trackEvent(DPG_EVENTS.DPG_BANNER_TAP, {});
    }
  };

  render() {
    const { entityId } = this.state;
    return entityId ? (
      <View style={styles.whiteBg}>
        <FetchCMSEntity trackEvent={this.trackEvent} id={entityId} />
      </View>
    ) : (
      <View style={styles.stretchFill}>
        <ActivityIndicator color={colors.primary} size="large" />
      </View>
    );
  }
}

const mstp = ({ cart, auth }) => {
  return {
    user_id: auth.user?.user_id,
  };
};

const styles = StyleSheet.create({
  whiteBg: {
    backgroundColor: "white",
  },
  stretchFill: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default connect(mstp)(DailyGreetings);
